$(document).ready(function() {    

    var currentURL = window.location.href;

    var isStandaloneDonation = currentURL.indexOf("DonationContent-Donation") > -1 
                            || currentURL.indexOf("donation-modal-self-checkout") > -1;

    if (isStandaloneDonation) {
        // Open only if header.js hasn't already opened it via #donatenow
        if (!window.__donationModalOpened && typeof showGuestCheckoutModal === 'function') {
            window.__donationModalOpened = true;
            setTimeout(function() {
                showGuestCheckoutModal();
            }, 300);
        }

        // Close button: return to referring domain if saved, else use browser history
        $('#maf-close-donation-back-history, #maf-close-donation-mobile-back-history').on('click', function (e) {
            var returnUrl = sessionStorage.getItem('donationReturnUrl');
            if (returnUrl) {
                sessionStorage.removeItem('donationReturnUrl');
                window.location.href = returnUrl;
                return;
            }
            history.back();
        });
    }
    // if (currentURL.indexOf("DonationContent-Donation") > -1 || currentURL.indexOf("donation-modal-self-checkout") > -1) {
    //     setTimeout(function(){
    //         $('#plantoday a[data-analytics="nav-donation-1"]').trigger('click');
    //     }, 333);

    //     // Updated close button logic for Donation Modal Only
    //     $('#maf-close-donation-back-history, #maf-close-donation-mobile-back-history').on('click', function (e) {
    //         history.back();
    //     });
    // };

    
    // --- Utility Function to Parse URL Parameters ---
    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        // This regex looks for name=value in the query string
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        // Decode the URL component or return empty string
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    // 1. Get parameters from the URL
    var donationType = getUrlParameter('donation').toLowerCase(); // 'onetime' or 'monthly'
    var donationAmount = getUrlParameter('amount'); // e.g., '15' or '42'

    // Exit if essential parameters are missing
    if (!donationType || !donationAmount) {
        console.log('No valid "donation" or "amount" URL parameters found. Using form defaults.');
        return;
    }

    // 2. Determine target selectors based on donation type
    var targetTabId;
    var targetPaneId;
    var fixedRadioName;
    var customRadioId;
    var customInputId;

    if (donationType === 'onetime') {
        targetTabId = '#pills-home-tab';
        targetPaneId = '#pills-home';
        fixedRadioName = 'amt_onetime';
        customRadioId = '#onetime_other_radio';
        customInputId = '#onetime_other_input';
    } else if (donationType === 'monthly') {
        targetTabId = '#pills-profile-tab';
        targetPaneId = '#pills-profile';
        fixedRadioName = 'amt_monthly'; 
        // Note: Monthly custom radio uses a different name for SFCC compatibility
        customRadioId = '#monthly_other_radio'; 
        customInputId = '#monthly_other_input';
    } else {
        console.warn('Unrecognized donation type: ' + donationType);
        return;
    }

    console.log('Pre-selecting Donation: Type=' + donationType + ', Amount=' + donationAmount);

    // 3. Activate the correct tab/pane
    function activateTab(tabId, paneId) {
        // Deactivate all tabs/pills
        $('#pills-tab .nav-link').removeClass('active').attr('aria-selected', 'false');
        $('#pills-tabContent .tab-pane').removeClass('active show');

        // Activate target tab link
        $(tabId).addClass('active').attr('aria-selected', 'true');
        
        // Activate target tab content pane
        $(paneId).addClass('active show');
        
        // If using Bootstrap's JS tab component, you might alternatively use:
        // $(tabId).tab('show');
    }
    activateTab(targetTabId, targetPaneId);

    // 4. Select the amount
    var fixedRadioSelector = 'input[name="' + fixedRadioName + '"][value="' + donationAmount + '"]';
    var $fixedRadio = $(fixedRadioSelector);

    if ($fixedRadio.length) {
        // A matching fixed amount radio button exists
        $fixedRadio.prop('checked', true);
        console.log('Selected fixed amount: $' + donationAmount);

        // Ensure custom field is clear and unchecked if it shares the same radio group name (One Time case)
        if (donationType === 'onetime') {
            $(customRadioId).prop('checked', false);
            $(customInputId).val('');
        }
    } else {
        // It is a custom amount
        console.log('Amount $' + donationAmount + ' is a custom amount. Activating custom input.');

        // 4a. Select the Custom Amount radio button
        $(customRadioId).prop('checked', true);

        // 4b. Set the value in the custom input field
        $(customInputId).val(donationAmount).trigger('change');
        
        // 4c. Ensure all fixed amounts are unchecked
        $('input[name="' + fixedRadioName + '"]').prop('checked', false);
    }


});
